import _find from 'lodash/find';

const writer = (property) => {
  let returnURL = '/';
  if (property.links) {
    let weburl = _find(property.links, {rel: 'othWebUrl'});
    if (weburl?.href) {
      returnURL =  weburl.href.replace(/https?:\/\/.*\.onthehouse.com.au/, ''); // remove the domain. the domain is there because MSG uses this url
    }
  }
  return returnURL;
};

export default writer;
